const {
  IS_LOADING,
  FANTASY_POINTS_SUCCESS,
  FANTASY_POINTS_ERROR,
  FANTASY_POINTS_UPDATED_SUCCESS,
  FANTASY_POINTS_UPDATED_ERROR,
} = require("../actions/Type");

const initialState = {
  fantasy_points: {},
  fantasy_points_update_message:{},
  loading: false,
};

export  const FantasyPointsReducers = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case FANTASY_POINTS_SUCCESS:
      return {
        ...state,
        fantasy_points: payload,
        loading: false,
      };
    case FANTASY_POINTS_ERROR:
      return {
        ...state,
        fantasy_points: payload,
        loading: false,
      };
      case FANTASY_POINTS_UPDATED_SUCCESS:
        return {
          ...state,
          fantasy_points_update_message: payload,
          loading: false,
        };
        case FANTASY_POINTS_UPDATED_ERROR:
        return {
          ...state,
          fantasy_points_update_message: payload,
          loading: false,
        };
    default:
      return state;
  }
};
